export enum Routes {
  BillableCount = 'contactdb/recipients/billable_count',
}
